import isPermissionEnabled from "common/isPermissionEnabled"

export const isCustomerSubPermissionEnabled = (
  subPermissions,
  permissionId
) => Boolean(subPermissions?.[permissionId]?.isEnabled)

export const canViewCustomerWalletHistory = subPermissions =>
  isCustomerSubPermissionEnabled(subPermissions, "view_wallet_history")

export const canViewCustomerGiftCardUsage = (
  subPermissions,
  userRole,
  accountType,
  accountScope
) =>
  isCustomerSubPermissionEnabled(subPermissions, "view_gift_card_usage") &&
  isPermissionEnabled(userRole, 37, "gift_card_1", accountType, accountScope)
